import { RowCrudStatus } from "../../common/types";
import {
  MusicalGenre,
  MusicalGenreCreateMutationVariables,
  MusicalGenreUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";

export type MusicalGenreValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
};

export type MusicalGenreErrorsType = {
  name?: { message: string; fieldLabel: string };
};

export function MusicalGenreValuesInit(): MusicalGenreValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
  };
}

export type MusicalGenreType = MusicalGenre | MusicalGenreValuesType;

export function musicalGenreDisplayId(
  source: Partial<MusicalGenre>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getMusicalGenreValues(
  source: MusicalGenreType,
  _langStore: LangStore,
  _duplicated: boolean = false
): MusicalGenreValuesType {
  const entityValues = MusicalGenreValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : musicalGenreDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getMusicalGenreUpdateVariables(
  values: MusicalGenreValuesType
): MusicalGenreUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
  };
}

export function getMusicalGenreCreateVariables(
  values: MusicalGenreValuesType
): MusicalGenreCreateMutationVariables {
  return {
    name: values.name,
  };
}
